const Privacy = () => {
  return <div>Privacy policy</div>;
};

export default Privacy;
